import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

import { DEFAULT_TOOLTIP_DELAY } from '../../../config/config';
import { useFreeTrialTrackingAttributes } from '../../utils/googleTagManagerAttributes';
import { OverlayTrigger, Tooltip } from '../../utils/tooltipReExports';

interface Props {
    termsAccepted: boolean;
    atLeastOneAssetBookable: boolean;
    onClick: () => void;
}

export const RenewDialogUpdateButton = (props: Props) => {
    const { termsAccepted, onClick, atLeastOneAssetBookable } = props;
    const freeTrialTrackingAttributes = useFreeTrialTrackingAttributes('click');

    if (termsAccepted && atLeastOneAssetBookable) {
        return (
            <Button
                className='btn btn-primary'
                onClick={onClick}
                autoTrackingKey='marketplace.contracts.updateRenewal'
                {...freeTrialTrackingAttributes}
            >
                <FormattedMessage id={'intl-msg:marketplace.contracts.updateRenewal'} />
            </Button>
        );
    }

    if (!atLeastOneAssetBookable) {
        return <RenewDialogUpdateButtonDisabled labelId={'intl-msg:marketplace.conditionsNotMet'} />;
    }

    return <RenewDialogUpdateButtonDisabled labelId={'intl-msg:marketplace.termsAndConditionsNotAccepted.hint'} />;
};

const RenewDialogUpdateButtonDisabled = ({ labelId }: { labelId: string }) => {
    const tooltip = (
        <Tooltip className={'width-auto max-width-300'}>
            <FormattedMessage id={labelId} />
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={'top'}
            trigger={OverlayTrigger.TRIGGER_HOVER}
            overlay={tooltip}
            delay={DEFAULT_TOOLTIP_DELAY}
        >
            <span className={'display-inline-block'}>
                <Button
                    type='button'
                    className={'btn btn-primary disabled'}
                    disabled
                    autoTrackingKey='marketplace.contracts.updateRenewal'
                >
                    <FormattedMessage id={'intl-msg:marketplace.contracts.updateRenewal'} />
                </Button>
            </span>
        </OverlayTrigger>
    );
};
